/*
 * @Description: 接口的版本号及相关公用设置
 * @Author: gao shuai
 * @Date: 2020-02-25 15:38:30
 * @LastEditTime: 2020-08-22 11:30:47
 * @LastEditors: gao shuai
 */

export const version = 1; // 接口的版本
export const authUrl = 'VUE_APP_AUTH_URL'; // 5000
export const downSentUrl = 'VUE_APP_TENANT_URL';
export const url = 'VUE_APP_MANAGE_URL'; 
export const merchentUrl =  'VUE_APP_MANAGE_MERCHART_URL/#/agentLogin'; // 进商户地址
export const loginUrl = 'VUE_APP_SERVER_URL'; // 登录地址
